module.exports = __webpack_public_path__ + "static/media/insurecomp_new.04c763a1.png";